<template>
    <div>
    <span  v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
    <div style="text-align:left;padding:20px;background-color:#ffffff;">
           <v-table style="background-color:#ffffff;"><tr>


            <td>
           <h4 class="text-h5">
                {{ k }}
           </h4></td></tr></v-table>
         </div>

        <v-tabs
            bg-color="#ffffff"
            color="#01579B"
            align-tabs="left"
        >
            <v-tab>
                <router-link style="text-decoration:none;"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-indel-details/${ k }`
                         }"
                ><v-btn id="variant-nav-bar-summary" elevation="3" style="padding:0;">
                    <span
                        v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='summary', 'var-nav-bar-btn-default': this.varPage != 'summary' }">
                        Genomic Data
                    </span>
                 </v-btn>
                </router-link>
            </v-tab>

            <v-tab>
                <router-link style="text-decoration:none;"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-indel-details/${ k }/protein`,
                     }"
                ><v-btn id="indel-nav-bar-protein" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='protein', 'var-nav-bar-btn-default': this.varPage != 'protein' }"
                 >
                    Protein
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>

            <v-tab>
                <router-link style="text-decoration:none;"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-indel-details/${ k }/treatments`,
                     }"
                >
                <v-btn id="variant-nav-bar-treatments" elevation="3" style="padding:0;">
                     <span
                             v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='treatments', 'var-nav-bar-btn-default': this.varPage != 'treatments' }"
                     >
                        Treatments
                     </span>
                 </v-btn>
                </router-link>
            </v-tab>

            <!--<v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-variant-details-q/${ item['UTA_Adapter']['gene_name'] }:${ item['UTA_Adapter']['variant_exchange'] }/nearby-treatments`,
                     }"
                >
                <v-btn id="variant-nav-bar-treatments" elevation="3" style="padding:0;">
                     <span
                             v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='nearby-treatments', 'var-nav-bar-btn-default': this.varPage != 'nearby-treatments' }"
                     >
                        Nearby Biomarkers
                     </span>
                 </v-btn>
                </router-link>
            </v-tab>-->

        </v-tabs>
        </span>
    </div>
</template>
<script>
import variant_annotation from "@/methods/variant_annotation";

export default {
    name: 'InDelViewNavBar',
    props: {
        item: {}
    },
    data () {
        return {
            varPage: "summary",
        }
    },
    methods: {
    },
    created: async function() {
        if (this.$route.path) {
            let route_parts = this.$route.path.split("/")
            if (route_parts.length>3) {
                this.varPage = route_parts[ route_parts.length-1 ]
            } else {
                this.varPage = "summary"
            }
        }
    },
    mounted: async function() {

    }
}
</script>
<style>
.var-nav-bar-btn-selected {
    background-color: #58b3e0;
    padding-left: 20px; padding-right: 20px;
    padding-top: 10px; padding-bottom: 10px;
}
.var-nav-bar-btn-default {
    background-color: #FFFFFF;
    padding-left: 20px; padding-right: 20px;
    padding-top: 10px; padding-bottom: 10px;
}
</style>
